import { OfferPriceRange } from '../services/prevention-offers.service';

/**
 * Formatage monétaire (Lot 9.0-E.E.D) -- `Intl.NumberFormat` standard, jamais un symbole codé en
 * dur (le seul précédent du repo, `SiteComponent.formatPreventionPrice`, hardcode `€` pour EUR et
 * bascule sur le code brut sinon -- pas un pattern robuste à reprendre, section 8/39 du lot).
 * Pas de décimales pour un montant entier (49 €, jamais 49,00 €).
 */
export function formatMoney(amount: number, currency: string, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Résumé de prix "Mes Offres" (section 8) à partir de {@link OfferPriceRange}[] -- jamais une
 * comparaison mathématique entre devises différentes (`min(EUR, MAD)` n'a aucun sens). 0 site actif
 * -- jamais un faux "0 €" (une vraie fourchette 0→0 EUR resterait "0 €", ce cas-ci est l'ABSENCE de
 * prix, sémantiquement différent).
 */
export function formatPriceRangesSummary(
  ranges: OfferPriceRange[],
  locale: string,
  labels: { noActiveSite: string; variesBySite: string }
): string {
  if (ranges.length === 0) {
    return labels.noActiveSite;
  }
  if (ranges.length > 1) {
    return labels.variesBySite;
  }
  const range = ranges[0];
  if (range.minPrice === range.maxPrice) {
    return formatMoney(range.minPrice, range.currency, locale);
  }
  return `${formatMoney(range.minPrice, range.currency, locale)} – ${formatMoney(range.maxPrice, range.currency, locale)}`;
}
